<template>
    <div id="m-configs" style="height: 100%">
        <v-overlay v-show="multipleExporting">
            <v-progress-circular indeterminate color="primary"/>
        </v-overlay>
        <v-overlay v-if="loading">
            <v-progress-circular indeterminate color="primary"/>
        </v-overlay>
        <v-alert type="error" width="20%" v-else-if="message" style="margin-top: 50px;margin-left: 50%;left: -10%;">
            {{ message }}
        </v-alert>
        <v-card v-else elevation="0">
            <v-card-actions>
                <v-card elevation="0" outlined width="100%" class="mt-1">
                    <v-card-actions>
                        <v-btn elevation="0"
                               color="green"
                               class="white--text"
                               @click="onPressImportSave">
                            Export snapshots from CSV
                            <v-icon size="20" class="ml-2">mdi-database-export-outline</v-icon>
                        </v-btn>
                        <input ref="uploader"
                               class="d-none"
                               type="file"
                               accept="text/*"
                               @change="onFileChanged">
                    </v-card-actions>
                </v-card>
            </v-card-actions>
            <v-card-actions>
                <v-tabs v-model="tab" class="no-transition">
                    <v-tab key="tab-p-find-user">Find User
                        <v-icon size="20" style="margin-left: 8px">mdi-account-search-outline</v-icon>
                    </v-tab>
                    <v-tab key="tab-p-saves" :disabled="isDevelopment() == false">Saves
                        <v-icon size="20" style="margin-left: 8px">mdi-content-save-all-outline</v-icon>
                    </v-tab>
                </v-tabs>
            </v-card-actions>
            <v-card-actions>
                <v-card elevation="0" width="100%" class="ma-0 pa-0">
                    <v-card-actions class="ma-0 pa-0">
                        <v-card color="red" width="100%" class="ma-0 pa-0" elevation="0">
                            <v-tabs-items class="mt-0" v-model="tab">
                                <v-tab-item
                                        transition="fade-transition"
                                        reverse-transition="fade-transition"
                                        key="tab-p-find-user">
                                    <p-find-user></p-find-user>
                                </v-tab-item>
                                <v-tab-item
                                        transition="fade-transition"
                                        reverse-transition="fade-transition"
                                        key="tab-p-saves">
                                    <p-saves></p-saves>
                                </v-tab-item>
                            </v-tabs-items>
                        </v-card>
                    </v-card-actions>
                </v-card>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>

import UsersBackend from "@/modules/mprofiles/database/UsersBackend";
import PFindUser from "@/modules/mprofiles/views/find-user/p-find-user";
import PSaves from "@/modules/mprofiles/views/find-user/p-saves";
import {MultipleSnapshotsDownloader} from "@/modules/mprofiles/utils/MultipleSnapshotsDownloader";

export default {
    components: {PSaves, PFindUser},
    data: () => ({
        loading: true,
        message: "",
        tab: null,
        downloader: null,
        multipleExporting:false,
    }),
    methods: {
        isDevelopment(){
            return process.env.VUE_APP_FB_PROJECTID == 'mira-merge---development'
        },
        onPressImportSave(){
            window.addEventListener('focus', () => {
            }, {once: true})
            this.$refs.uploader.click()
        },
        onFileChanged(e) {
            this.multipleExporting = true;
            e.target.files[0].text()
                .then((data) => {
                    const uids = data.split('\n');
                    this.downloader = new MultipleSnapshotsDownloader(uids);
                    this.downloader.init();
                    var self = this;
                    this.downloader.setOnComplete(function (status){
                        console.log("done all", status);
                        self.multipleExporting = false;
                    })
                })
                .catch((error) => {
                    throw error
                })
        },
    },
    beforeMount() {
        this.loading = false
        this.$store.registerModule("users-backend", UsersBackend);
        this.$store.dispatch("users-backend/init").then(() => {
            console.log("Loaded successfully.");
        }).catch(() => {
            this.message = "Load failed!";
        }).finally(() => {
            this.loading = false;
        });
    },
    destroyed() {
        this.$store.unregisterModule("users-backend");
        console.log("destroy root view mprofiles");
    },
}

</script>

<style scoped>
</style>